// @ts-nocheck
import axios, { AxiosInstance } from 'axios';

const axiosInstance: AxiosInstance = axios.create({
  xsrfCookieName: 'eshares-csrftoken-2',
  xsrfHeaderName: 'X-CSRFToken',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  // This is here for development purposes
  // baseURL: 'http://localhost:8000',
});

// We are overriding Axios typing here.
// And this file is dev only.
axiosInstance.options = url =>
  axiosInstance({
    method: 'options',
    url,
  });

export default { ...axios, ...axiosInstance, axios: axiosInstance };
